export default {
  data() {
    return {
      scrollTarget: null,
      scrollObserver: new IntersectionObserver((e) => this.scrollEndHandler(e), { threshold: 1 }),
    };
  },
  watch: {
    establishments: {
      async handler() {
        if (this.scrollTarget) {
          this.scrollObserver.unobserve(this.scrollTarget);
        }
        await this.$nextTick();
        this.scrollTarget = this.$refs.tableRow.slice(-1)[0]?.$el;
        if (this.scrollTarget) {
          this.scrollObserver.observe(this.scrollTarget);
        }
      },
      deep: true,
    },
  },
  methods: {
    scrollEndHandler(e) {
      if (e[0].isIntersecting) {
        this.$emit('scrollEnd');
      }
    },
  },
};